module.exports = "/video-roulette/img/btn-background-green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/btn-background-green.png
// module id = 2433
// module chunks = 10